import { IDGDATA } from '@mummssoftware/utils/constants';
import { dateToYYMMDD, parseDateYYYYMMDD } from '@mummssoftware/utils/dates';
import { getFormDisplayName } from '@mummssoftware/utils/utils';
import { flowRight as compose } from 'lodash-es';

/** Rows the IDG Document widget can open (not Manifest-only). */
export const isQTypeNewIdg = (data: any) =>
  data?.qtype === 'idgv2' || data?.qtype === 'idgv3';

export const commonColumnDefs = {
  wrapText: true,
  sortable: true,
  filter: true,
  autoHeight: true,
  flex: 1,
  resizable: true,
  cellStyle: {
    display: 'inline-block',
    position: 'absolute',
    overflow: 'ellipsis',
  },
};

const tooltipValueGetter = (params: any) =>
  (!isQTypeNewIdg(params.data) &&
    'Currently, this document can only be viewed in the Manifest') ||
  '';

const formatDate = compose(dateToYYMMDD, parseDateYYYYMMDD);

const IDGAgendaDates = {
  headerName: 'IDG Agenda Dates',
  valueGetter: (params: any) =>
    (params.data.idgdata?.fromdate &&
      `${formatDate(params.data.idgdata?.fromdate)} / ${formatDate(
        params.data.idgdata?.todate,
      )}`) ||
    '',
  sort: 'desc',
  flex: 0.5,
  minWidth: 75,
  tooltipValueGetter,
};

const FormName = {
  headerName: 'Form Name',
  field: 'displayname',
  valueGetter: (params: any) =>
    `${
      ((params.data.source === 'IDGDATABACKFILL' ||
        params.data.source === 'IDGBACKFILL-IDGM') &&
        '* ') ||
      ''
    }${getFormDisplayName(params.data)}`,
  flex: 0.5,
  minWidth: 75,
  tooltipValueGetter,
};

const Type = {
  headerName: 'Type',
  field: 'qtype',
  flex: 0.5,
  minWidth: 75,
  tooltipValueGetter,
};

export const getColumnDefs = (smallWidget?: boolean) =>
  smallWidget ? [FormName, IDGAgendaDates] : [FormName, IDGAgendaDates, Type];
